import { useEffect, useMemo, useState } from "react";
import {
	buildResultTemplatesManager,
	ResultList as HeadlessResultList,
	ResultTemplatesManager,
	SearchEngine
} from "@coveo/headless";
import generateResultsJSXElements from "components/coveo-headless/controllers/ResultTemplateManager";
import { CoveoHeadlessTemplate } from "components/coveo-headless/types/coveo-headless-types";

type SearchPageResultsProps = {
	controller: HeadlessResultList;
	headlessEngine: SearchEngine;
	showMoreText: string;
	templates: CoveoHeadlessTemplate[];
};

const SearchPageResults = ({
	controller,
	headlessEngine,
	showMoreText,
	templates
}: SearchPageResultsProps) => {
	const [state, setState] = useState(controller.state);

	useEffect(() => {
		controller.subscribe(() => {
			setState(controller.state);
		});
	}, [controller]);

	const resultTemplatesManager: ResultTemplatesManager = useMemo(
		() => buildResultTemplatesManager(headlessEngine),
		[headlessEngine]
	);
	resultTemplatesManager.registerTemplates(
		...generateResultsJSXElements(templates, headlessEngine)
	);

	const showMoreButton = () => {
		if (state.moreResultsAvailable) {
			if (state.isLoading) {
				return <div className="coveo-headless-loading-spinner"></div>;
			}
			return (
				<button
					className="coveo-headless-results-show-more-button t-label-sm-heavy search-page-results-show-more-button"
					data-qa="client-search-results-show-more-button"
					onClick={() => {
						controller.fetchMoreResults();
					}}
				>
					{showMoreText}
				</button>
			);
		}
		return null;
	};

	return (
		<div className="search-page-results-container" data-qa="client-search-results-container">
			{state.results.length
				? state.results.map((result) => {
						// set to any as they do in coveo examples to prevent a TS error in the return statement
						// eslint-disable-next-line @typescript-eslint/no-explicit-any
						const template: any = resultTemplatesManager.selectTemplate(result);
						if (!template) throw new Error(`No result template provided for ${result.title}.`);

						return template(result);
					})
				: null}

			{showMoreButton()}
		</div>
	);
};

export default SearchPageResults;
